import React from "react";
import { FcGoogle } from "react-icons/fc";
import { FaGithub, FaFacebook } from "react-icons/fa";

const PROVIDERS = [
  { id: "google", icon: <FcGoogle className="text-xl" /> },
  { id: "github", icon: <FaGithub className="text-xl text-gray-800 dark:text-white" /> },
  { id: "facebook", icon: <FaFacebook className="text-xl text-blue-600" /> },
];

const SocialAuthButtons = ({ disabled, onSelect }) => (
  <div className="mb-6 grid grid-cols-3 gap-3">
    {PROVIDERS.map(({ id, icon }) => (
      <button
        key={id}
        type="button"
        onClick={() => onSelect(id)}
        disabled={disabled}
        className="flex items-center justify-center rounded-lg bg-gray-50 py-2.5 transition-all hover:bg-gray-100 disabled:cursor-not-allowed disabled:opacity-70 dark:bg-black/30 dark:hover:bg-black/50"
      >
        {icon}
      </button>
    ))}
  </div>
);

export default SocialAuthButtons;
